var _path, _mask, _path2, _path3, _circle, _circle2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaverSolutionLine1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2498 30.0207L35.4247 25.6621H85.0383C89.413 25.6621 92.9593 29.2085 92.9593 33.5832V37.2534H54.7554C52.1229 37.2534 49.6625 35.9456 48.1898 33.7636L47.6938 33.0288C46.8267 31.7439 45.6397 30.7072 44.2498 30.0207Z",
    stroke: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2137_20406",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8307 28.1985C50.2308 26.2747 47.8583 25.1621 45.3562 25.1621H26.216C21.5652 25.1621 17.7949 28.9323 17.7949 33.5832V85.3854C17.7949 90.0362 21.5652 93.8064 26.216 93.8064H97.6842C102.335 93.8064 106.105 90.0362 106.105 85.3854V44.3881C106.105 39.7373 102.335 35.967 97.6842 35.967H62.2409C59.7389 35.967 57.3663 34.8544 55.7664 32.9307L51.8307 28.1985Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8307 28.1985C50.2308 26.2747 47.8583 25.1621 45.3562 25.1621H26.216C21.5652 25.1621 17.7949 28.9323 17.7949 33.5832V85.3854C17.7949 90.0362 21.5652 93.8064 26.216 93.8064H97.6842C102.335 93.8064 106.105 90.0362 106.105 85.3854V44.3881C106.105 39.7373 102.335 35.967 97.6842 35.967H62.2409C59.7389 35.967 57.3663 34.8544 55.7664 32.9307L51.8307 28.1985Z",
    fill: "#31E89F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7664 32.9307L56.5353 32.2913L56.5353 32.2913L55.7664 32.9307ZM26.216 26.1621H45.3562V24.1621H26.216V26.1621ZM18.7949 33.5832C18.7949 29.4846 22.1174 26.1621 26.216 26.1621V24.1621C21.0129 24.1621 16.7949 28.3801 16.7949 33.5832H18.7949ZM18.7949 85.3854V33.5832H16.7949V85.3854H18.7949ZM26.216 92.8064C22.1174 92.8064 18.7949 89.4839 18.7949 85.3854H16.7949C16.7949 90.5885 21.0129 94.8064 26.216 94.8064V92.8064ZM97.6842 92.8064H26.216V94.8064H97.6842V92.8064ZM105.105 85.3854C105.105 89.4839 101.783 92.8064 97.6842 92.8064V94.8064C102.887 94.8064 107.105 90.5885 107.105 85.3854H105.105ZM105.105 44.3881V85.3854H107.105V44.3881H105.105ZM97.6842 34.967H62.2409V36.967H97.6842V34.967ZM62.2409 34.967C60.036 34.967 57.9452 33.9865 56.5353 32.2913L54.9976 33.5701C56.7875 35.7223 59.4417 36.967 62.2409 36.967V34.967ZM56.5353 32.2913L52.5996 27.559L51.0619 28.8379L54.9976 33.5701L56.5353 32.2913ZM107.105 44.3881C107.105 39.185 102.887 34.967 97.6842 34.967V36.967C101.783 36.967 105.105 40.2896 105.105 44.3881H107.105ZM45.3562 26.1621C47.5612 26.1621 49.652 27.1426 51.0619 28.8379L52.5996 27.559C50.8097 25.4069 48.1554 24.1621 45.3562 24.1621V26.1621Z",
    fill: "white",
    mask: "url(#path-2-inside-1_2137_20406)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 98.4266,
    cy: 43.8377,
    r: 1.9598,
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.2586,
    cy: 43.8377,
    r: 1.9598,
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5332 73.2165L40.5133 61.2359L52.4939 73.2165L69.1548 56.5557M69.1548 56.5557H59.2748M69.1548 56.5557V65.9258",
    stroke: "white",
    strokeWidth: 5.05263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaverSolutionLine1);
export default __webpack_public_path__ + "static/media/naverSolutionLine1.db419e65bf05ea2bade24cbecba78adb.svg";
export { ForwardRef as ReactComponent };